import { useEffect, useState } from "react";
import axios from "axios";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const LINKS = [
  { key: "about_us", label: "About Us" },
  { key: "terms", label: "Terms & Conditions" },
  { key: "contact_us", label: "Contact Us" },
];

export const SiteFooter = () => {
  const [info, setInfo] = useState({});
  const [open, setOpen] = useState(null);

  useEffect(() => {
    axios.get(`${API}/public/site-info`).then((r) => setInfo(r.data || {})).catch(() => {});
  }, []);

  const shown = LINKS.filter((l) => (info[l.key] || "").trim());
  const cur = LINKS.find((l) => l.key === open);

  return (
    <footer className="bg-slate-900 text-slate-300 mt-auto" data-testid="site-footer">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
        {shown.length > 0 && (
          <nav className="flex flex-wrap justify-center gap-x-5 gap-y-1 text-sm">
            {shown.map((l) => (
              <button key={l.key} onClick={() => setOpen(l.key)} className="hover:text-white underline-offset-4 hover:underline transition-colors" data-testid={`footer-link-${l.key}`}>{l.label}</button>
            ))}
          </nav>
        )}
        <p className="text-xs text-slate-400 text-center" data-testid="footer-copyright">
          Copyright © {new Date().getFullYear()} All Rights Reserved by <span className="text-white font-semibold">{info.copyright_by || "Sootrik"}</span>
        </p>
      </div>
      <Dialog open={!!cur} onOpenChange={(v) => !v && setOpen(null)}>
        <DialogContent className="max-w-lg max-h-[85vh] overflow-y-auto" data-testid="footer-dialog">
          <DialogHeader><DialogTitle>{cur?.label}</DialogTitle></DialogHeader>
          <div className="text-sm whitespace-pre-wrap leading-relaxed text-slate-700" data-testid="footer-dialog-content">{cur && info[cur.key]}</div>
        </DialogContent>
      </Dialog>
    </footer>
  );
};
